import React from "react";
import img from "../../assets/advisory.webp";

const Advisory = () => {
  return (
    <div
      id="advisory"
      className="my-[100px]  flex flex-col gap-10 w-[85%] mx-auto"
    >
      <div className="relative text-center my-5 ">
        <h1 className="text-4xl dark:text-white font-extrabold md:text-7xl font-mono text-center text-[#4f1951] leading-normal">
          Advisory
        </h1>
        <div
          className="dark:bg-custom-gradient"
          style={{
            position: "absolute",
            width: "320.95px",
            height: "157.05px",
            left: "50%", // Center horizontally
            top: "50%", // Center vertically
            transform: "translate(-50%, -50%) matrix(1, 0, -0.03, 1, 0, 0)", // Adjust for precise positioning
            opacity: 0.2,
            filter: "blur(34px)",
            borderRadius: "50%",
            zIndex: "0", // Ensure it's behind the text
          }}
        ></div>
      </div>

      <div className="flex flex-col xl:flex-row gap-10 items-center ">
        <img
          src={img}
          className="rounded-lg cursor-pointer duration-300 hover:scale-110"
          alt="Advisory"
        />
        <div className="flex flex-col gap-5 dark:text-light items-start justify-start">
          <p className="text-lg font-serif font-bold ">
            Confidently plan and execute your strategy and business
            transformation milestones
          </p>
          <p className="font-light font-sans text-sm">
            You operate in a complex, ever-changing and uncertain environment.
            Whether a government agency or a private corporation, we enable you
            to navigate disruption and thrive in a fast-moving landscape.
          </p>
          <p className="font-light font-sans text-sm">
            Get to the heart of the business problem you need to solve through
            our strategic capabilities across business operations analysis,
            business transformation, infrastructure, apps, analytics and AI
            technologies.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Advisory;
